import { useSelector } from "react-redux";
import { selectUser } from "app/slice/selectors";

export const useCustomerServices = () => {
  const user = useSelector(selectUser);
  const userData = user as any;

  const customer =
    userData?.customer && typeof userData.customer === "object"
      ? userData.customer
      : undefined;

  const customerId =
    userData?._id ??
    userData?.customerId ??
    userData?.id ??
    customer?._id ??
    customer?.customerId ??
    customer?.id ??
    userData?.data?._id ??
    userData?.data?.customerId ??
    userData?.data?.id ??
    "";

  // Check networkType in both root and nested data object
  const networkType = userData?.networkType ?? userData?.data?.networkType;
  const hasTrialDigitalSecurityPlan =
    userData?.hasTrialDigitalSecurityPlan ??
    userData?.data?.hasTrialDigitalSecurityPlan;

  // Standardize: mobile service is available when a network type exists OR trial digital security is active
  const hasMobileService =
    (networkType !== null && networkType !== undefined) ||
    hasTrialDigitalSecurityPlan === true;

  // Check isFixedPhone in both root and nested data object
  // Standardize: Has fixed phone service if isFixedPhone is explicitly true
  const isFixedPhone = userData?.isFixedPhone ?? userData?.data?.isFixedPhone;
  const hasFixedPhoneService = isFixedPhone === true;

  /** First mobile tab label + DS-only layouts: full Digital Security (networkType 3) or trial digital security. */
  const isDigitalSecurityCustomer =
    networkType === 3 || hasTrialDigitalSecurityPlan === true;

  const networkTypeNum =
    networkType === null || networkType === undefined || networkType === ""
      ? NaN
      : Number(networkType);

  /** Active cellular mobile plan (standard / dual eSIM). */
  const hasCellularMobile =
    networkTypeNum === 1 || networkTypeNum === 2;

  /** Active Digital Security plan or trial. */
  const hasDigitalSecurityPlan =
    networkTypeNum === 3 || hasTrialDigitalSecurityPlan === true;

  return {
    customerId,
    hasMobileService,
    hasFixedPhoneService,
    hasTrialDigitalSecurityPlan: hasTrialDigitalSecurityPlan === true,
    isDigitalSecurityCustomer,
    hasCellularMobile,
    hasDigitalSecurityPlan,
    user: userData,
    networkType,
  };
};
